import { create } from "zustand";
import {
  persist,
  PersistOptions,
  StateStorage,
  PersistStorage,
} from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

type StoreCreator<T> = (
  set: (fn: (state: T) => void) => void,
  get: () => T,
) => T;

export const createAppStore = <T>(
  storeCreator: StoreCreator<T>,
  persistKey?: string,
  storage?: StateStorage | PersistStorage<T>,
  onRehydrateStorage?: PersistOptions<T>["onRehydrateStorage"],
) => {
  return persistKey
    ? create<T>()(
        persist(
          immer((set, get) =>
            storeCreator(set as (fn: (state: T) => void) => void, get),
          ),
          {
            name: persistKey,
            ...(storage ? { storage } : {}),
            ...(onRehydrateStorage ? { onRehydrateStorage } : {}),
            partialize: (state) => {
              const plainState = { ...state };
              for (const key in plainState) {
                if (typeof plainState[key] === "function") {
                  delete plainState[key]; // remove functions before persisting
                }
              }
              return plainState;
            },
          } as PersistOptions<T>,
        ),
      )
    : create<T>()(
        immer((set, get) =>
          storeCreator(set as (fn: (state: T) => void) => void, get),
        ),
      );
};
